import React, { useState, useEffect } from "react";
import { Typography, Box, TextField } from "@mui/material";
import { CommonDialog } from "../Components/CommonQuickAdd";
import { addJobTitle } from "../api";
import { useSnackbar } from "notistack";

const AddJobTitle = ({ open, onClose, onSuccess }) => {
  const [actionLoading, setActionLoading] = useState(false);
  const [formData, setFormData] = useState({
    Name: "",
    Description: "",
  });
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (!open) {
      setFormData({ Name: "", Description: "" });
    }
  }, [open]);

  const extractCreatedJobTitle = (response, fallbackName) => {
    const idCandidates = [
      response?.ID,
      response?.Id,
      response?.JobID,
      response?.JobTitleID,
      response?.Data?.ID,
      response?.Data?.Id,
      response?.Data?.JobID,
      response?.Data?.JobTitleID,
      response?.Result?.ID,
      response?.Result?.Id,
      response?.Result?.JobID,
      response?.Result?.JobTitleID,
    ];

    const nameCandidates = [
      response?.JobTitle,
      response?.Name,
      response?.Data?.JobTitle,
      response?.Data?.Name,
      response?.Result?.JobTitle,
      response?.Result?.Name,
      fallbackName,
    ];

    const id = idCandidates.find(
      (value) => value !== undefined && value !== null && value !== "",
    );
    const label = nameCandidates.find(
      (value) => typeof value === "string" && value.trim(),
    );

    return {
      value: id ? String(id) : "",
      label: label ? label.trim() : "",
    };
  };

  const handleSave = async () => {
    setActionLoading(true);
    try {
      const name = formData.Name?.trim();
      const payload = {
        Name: name,
        Description: formData.Description?.trim() || null,
      };

      const response = await addJobTitle(payload);

      if (response?.StatusCode === 200) {
        const createdJobTitle = extractCreatedJobTitle(response, name);
        enqueueSnackbar(response?.Status, { variant: "success" });
        await onSuccess?.(createdJobTitle);
        onClose();
      }
        else {
        enqueueSnackbar(response?.Status, { variant: "error" });
      }
    } catch (error) {
      throw error;
    } finally {
      setActionLoading(false);
    }
  };

  // const handleCancel = () => {
  //   onClose();
  // };

  return (
    <CommonDialog
      open={open}
      onClose={onClose}
      title="Add New JobTitle"
      loading={actionLoading}
      onSave={handleSave}
    >
      <Box>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Typography sx={{ width: 180, fontSize: "11px" }}>
            Add New JobTitle<span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            size="small"
            fullWidth
            value={formData.Name}
            onChange={(e) =>
              setFormData({ ...formData, Name: e.target.value })
            }
            sx={{
              maxWidth: 250,
              "& .MuiOutlinedInput-root": {
                height: "28px",
                fontSize: "12px",
              },
              "& .MuiOutlinedInput-input": {
                padding: "4px 8px",
                fontSize: "12px",
              },
            }}
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <Typography sx={{ width: 180, fontSize: "11px" }}>
            Description
          </Typography>
          <TextField
            size="small"
            fullWidth
            value={formData.Description}
            onChange={(e) =>
              setFormData({ ...formData, Description: e.target.value })
            }
            sx={{
              maxWidth: 250,
              "& .MuiOutlinedInput-root": {
                height: "28px",
                fontSize: "12px",
              },
              "& .MuiOutlinedInput-input": {
                padding: "4px 8px",
                fontSize: "12px",
              },
            }}
          />
        </Box>

      </Box>
    </CommonDialog>
  );
};

export default AddJobTitle;
